import axios from "axios";
import React, { useState, useEffect } from "react";
import { IoIosCheckmark, IoIosClose, IoMdArrowBack } from "react-icons/io";
import { ClipLoader } from "react-spinners";
import Top from "../components/Top";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";

const CandidateHrProgress = ({ currentUser }) => {
    const { candidateId } = useParams();
    const [candidate, setCandidate] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            let response = await axios.post(
                `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                }/api/v1/get-candidate-progress`,
                {
                    candidate_id: candidateId,
                },
                {
                    withCredentials: true
                }
            );
            setCandidate(response.data.candidate);
            if (response.data.hrAnswer?.answers) {
                setAnswers(response.data.hrAnswer.answers);
            } else {
                setAnswers([]);
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    const handleBack = async () => {
        navigate(-1);
    }

    return (
        <>
            {!loading ? (
                <div className="px-3 sm:px-6 xl:px-3 2xl:px-3 mt-3 mb-3">
                    <Top currentUser={currentUser} />
                    <Navbar currentUser={currentUser} />

                    <div className="w-full bg-white text-gray-900 rounded-xl sm:p-1 xl:p-2">
                        <div className="flex gap-2 items-center">
                            <div title="Back To Candidate Progress Dashboard" onClick={handleBack} className="bg-[#dddddd] hover:bg-[#cccccc] w-6 h-6 flex items-center justify-center rounded-full cursor-pointer">
                                <IoMdArrowBack size={"1em"} />
                            </div>
                            <h1 className=" font-semibold text-[16px] leading-10 tracking-[1%] sm:text-[20px] sm:leading-tight sm:tracking-[1%] xl:text-xl xl:leading-tight xl:tracking-[1%] 2xl:text-2xl 2xl:leading-tight 2xl:tracking-[1%] text-[#86203B]">
                                HR Assessment Result
                            </h1>
                        </div>


                        <div className="bg-[#FDFDFD] p-1 xl:p-2 px-2 mt-1 xl:mt-2 flex flex-col xl:flex xl:flex-row gap-1 xl:gap-10 justify-between xl:items-center border border-[#00000012] rounded-[12px]">
                            <div>
                                <h2 className="flex gap-2 font-semibold text-[14px] tracking-[1%] sm:text-[16px] sm:tracking-[1%] xl:text-[16px] xl:tracking-[1%] 2xl:text-[16px] 2xl:leading-loose 2xl:tracking-[1%] xxl:leading-[59px] xxl:tracking-[1%] text-[#B91541]">
                                    {candidate.name}
                                    <p className={`${answers[0]?.option === "No, I am not authorized" ? "text-[#DC4A4A]" : "text-[#0AA451]"} text-[12px] leading-none border border-[#0E2B643D] flex items-center px-2 sm:px-3 xl:px-3 rounded-[24px]`}>
                                        {answers[0]?.option === "No, I am not authorized" ? "Fail" : "Pass"}
                                    </p>
                                </h2>
                                <p className="text-[#000000]  font-semibold text-[12px] leading-normal tracking-[1%] sm:text-sm sm:leading-normal sm:tracking-[1%] sm:text-start xl:text-base xl:leading-relaxed xl:tracking-[1%] xl:text-left 2xl:text-lg 2xl:leading-loose 2xl:tracking-[1%] 2xl:text-left xxl:leading-[30px] xxl:tracking-[1%] xxl:text-left">
                                    {candidate.job_title}
                                </p>
                            </div>
                            <div className="xl:flex xl:flex-row sm:flex sm:flex-row flex flex-col sm:gap-8 xl:gap-10  font-semibold text-base leading-normal tracking-[1%] text-[10px] sm:text-[12px] sm:leading-normal sm:tracking-[1%] xl:text-[12px] xl:leading-relaxed xl:tracking-[1%] 2xl:text-[16px] 2xl:leading-loose 2xl:tracking-[1%] xxl:leading-[30px] xxl:tracking-[1%] text-[#000000]">
                                <div className="flex flex-col w-[50%] border-r-0 sm:border-r xl:border-r border-[#BEBEBE]">
                                    <p className="flex gap-4">
                                        <span className="sm:w-24 xl:w-28">Job Code:</span>{" "}
                                        <span className="font-normal">{candidate.job_code}</span>
                                    </p>
                                    <p className="flex gap-4">
                                        <span className="sm:w-24 xl:w-28">Applicant Id:</span>{" "}
                                        <span className="font-normal">
                                            {candidate.applicant_id}
                                        </span>
                                    </p>
                                </div>
                                <div className="flex flex-col w-[50%]">
                                    <p className="flex xl:gap-4">
                                        <span className="sm:w-24 xl:w-28">Email:</span>{" "}
                                        <span className="font-normal">{candidate.email}</span>
                                    </p>
                                    <p className="flex">
                                        <span className="sm:w-24 xl:w-28">Phone No:</span>{" "}
                                        <span className="font-normal">{candidate.phone_no}</span>
                                    </p>
                                </div>
                            </div>
                        </div>



                        <div className="flex flex-col gap-1 sm:gap-2 xl:gap-2 mt-1 sm:mt-2">
                            {answers.map((answer, index) => {
                                if (answer) {
                                    return <div
                                        key={index}
                                        className="p-2 sm:p-2 xl:p-2 border border-[#B4BBC8] rounded-[6px] sm:rounded-[6px] xl:rounded-[6px]"
                                    >
                                        <h2 className=" font-medium text-[12px] leading-none tracking-normal text-[#000000] sm:text-[14px] sm:leading-none sm:tracking-normal xl:text-[14px] xl:leading-none xl:tracking-normal 2xl:text-[14px] 2xl:leading-none 2xl:tracking-normal xxl:leading-none xxl:tracking-normal mb-1 sm:mb-1 xl:mb-1">
                                            Q{index + 1}. {answer?.text} {answer?.text === "What is your expected salary?" && "($USD)"}
                                        </h2>
                                        <ul className="list-disc  font-medium text-[10px] tracking-normal sm:text-[12px] sm:tracking-normal xl:text-[12px] xl:tracking-normal 2xl:text-[12px] 2xl:leading-none 2xl:tracking-normal xxl:tracking-normal">
                                            {answer?.text === "Which state do you currently reside in?" ? (
                                                <div className="flex items-center gap-5">
                                                    {answer?.option === "No, I am not authorized" ? (
                                                        <IoIosClose size={"1em"} color="#FC2D2D" />
                                                    ) : (
                                                        <IoIosCheckmark size={"1em"} color="#15D149" />
                                                    )}
                                                    <li className={answer?.option === "No, I am not authorized" ? "text-[#FC2D2D] w-[100%]" : "text-[#15D149] w-[100%]"}>
                                                        {answer?.option} 
                                                    </li>
                                                </div>
                                            ) : (
                                                answer?.options.map((option, i) => (
                                                    <div key={i} className="flex items-center gap-5">
                                                        {answer?.option === option ? (
                                                            option === "No, I am not authorized" ? (
                                                                <IoIosClose size={"1.4em"} color="#FC2D2D" />
                                                            ) : (
                                                                <IoIosCheckmark size={"1.4em"} color="#15D149" />
                                                            )
                                                        ) : (
                                                            <IoIosClose size={"1.4em"} color="transparent" />
                                                        )}

                                                        <li
                                                            className={
                                                                answer?.option === option
                                                                    ? option === "No, I am not authorized"
                                                                        ? "text-[#FC2D2D] w-[100%]"
                                                                        : "text-[#15D149] w-[100%]"
                                                                    : "w-[100%]"
                                                            }
                                                        >
                                                            {option.split(" ")[0] === "Monthly" ? `Yearly Salary (W2 + Benefits) ${option.split(" ")[1]}` : option}
                                                        </li>
                                                    </div>
                                                ))
                                            )}
                                        </ul>
                                    </div>
                                }
                            })}
                        </div>
                    </div>
                </div>
            ) : (
                <ClipLoader className="absolute top-1/2 left-1/2 -translate-1/2" />
            )}
        </>
    );
};

export default CandidateHrProgress;
